import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit = 25, completeWords = true, ellipsis = '...') {
    if (!value) return '';
    if (value.length <= limit) return value;

    if (completeWords) {
      const lastSpace = value.substring(0, limit).lastIndexOf(' ');
      limit = lastSpace > -1 ? lastSpace : limit;
    }
    return `${value.substring(0, limit)}${ellipsis}`;
  }
} 